import { differenceWith, isEmpty, reject, symmetricDifferenceWith } from 'ramda';
import { handleActions } from 'redux-actions';

import * as types from './actionTypes';
import { RADIO_OPTIONS_IDS } from './constants';

export const initialState = {
	radio: RADIO_OPTIONS_IDS.byOrganizeStructure,
	guarantors: [], // data for result table and select field
	guarantorsOfRegion: [], // data for pills
	selectedGuarantors: [],
	enableSave: false,
};

const sameId = (x, y) => x.id === y.id;
const sameLogin = (x, y) => x.login === y.login;
const rejectSameIds = differenceWith(sameId);
const isSelected = (selectedGuarantors) => (guarantor) => selectedGuarantors.includes(guarantor.id);
const enableSave = (originalGuaratorsOfRegion, updatedGuarantorsOfRegion) => {
	const differences = symmetricDifferenceWith(sameLogin, originalGuaratorsOfRegion, updatedGuarantorsOfRegion);
	return !isEmpty(differences);
};

const reducerMap = {
	[types.SET_RADIO_BUTTON]: (state, { payload }) => {
		return {
			...state,
			radio: payload.radio,
			guarantors: [],
			selectedGuarantors: [],
		};
	},
	[types.SET_GUARANTORS_OF_REGION]: (state, { payload }) => {
		return {
			...state,
			guarantorsOfRegion: payload.guarantors,
		};
	},
	[types.ADD_GUARANTOR_OF_REGION]: (state, { payload }) => {
		return {
			...state,
			guarantorsOfRegion: state.guarantorsOfRegion.concat(payload.guarantor),
		};
	},
	[types.REMOVE_GUARANTOR_OF_REGION]: (state, { payload }) => {
		return {
			...state,
			guarantorsOfRegion: state.guarantorsOfRegion.filter((g) => g.id !== payload.id),
			enableSave: true,
		};
	},
	[types.SET_GUARANTORS]: (state, { payload }) => {
		return {
			...state,
			guarantors: rejectSameIds(payload.guarantors, state.guarantorsOfRegion),
			selectedGuarantors: [],
		};
	},
	[types.APPEND_GUARANTORS]: (state, { payload }) => {
		return {
			...state,
			guarantors: state.guarantors.concat(rejectSameIds(payload.guarantors, state.guarantorsOfRegion)),
		};
	},
	[types.ADD_GUARANTORS]: (state) => {
		const { guarantorsOfRegion, guarantors, selectedGuarantors } = state;
		const guarantorsToAdd = guarantors.filter(isSelected(selectedGuarantors));
		return {
			...state,
			selectedGuarantors: [],
			guarantors: reject(isSelected(selectedGuarantors), state.guarantors),
			guarantorsOfRegion: guarantorsOfRegion.concat(guarantorsToAdd),
			enableSave: true,
		};
	},
	[types.RESET_GUARANTORS]: (state) => {
		return {
			...state,
			guarantors: [],
			selectedGuarantors: [],
		};
	},
	[types.SELECT_GUARANTORS]: (state, { payload }) => {
		return {
			...state,
			selectedGuarantors: payload.guarantorIds,
		};
	},
	[types.RESET]: (state, { payload }) => {
		return {
			...initialState,
			radio: state.radio,
			guarantorsOfRegion: state.guarantorsOfRegion || initialState.guarantorsOfRegion,
			enableSave: enableSave(payload.guarantors, state.guarantorsOfRegion),
		};
	},
	[types.GUARANTORS_EDIT_HARD_RESET]: () => initialState,
};

export default handleActions(reducerMap, initialState);
